import useDialog from 'components/Dialog/useDialog';
import { useSelector } from 'react-redux';
import { literalTemplate } from 'utils/language';
import {
  createInvestmentAsset, deleteInvestmentAsset, getInvestmentAssets, updateInvestmentAsset,
} from 'modules/investmentAssets/repository';
import { OTHER } from 'constants/investmentAsset';

const useHandleAssets = ({ type, refresh }) => {
  const { dialog } = useDialog();
  const literals = useSelector((state) => state.i18n.literals.investmentAssets);

  const getInvestments = async (page, size, search) => getInvestmentAssets({
    page, size, search, filters: { type },
  });

  const createInvestment = async (auxData, id) => {
    const data = { ...auxData, type };

    if (id) {
      await updateInvestmentAsset(id, data);
    } else {
      await createInvestmentAsset(data);
    }
  };

  const deleteInvestment = async (id) => {
    const asset = type === OTHER ? literals.title : literals[type];
    const confirm = await dialog({
      type: 'confirmDanger',
      text: literalTemplate(literals.questionRemove, { ASSET: asset.toLowerCase() }),
    });

    if (confirm) {
      await dialog({
        type: 'loading',
        execute: async () => {
          await deleteInvestmentAsset(id);
          refresh();
        },
      });
    }
  };

  return {
    getInvestments,
    deleteInvestment,
    createInvestment,
  };
};

export default useHandleAssets;
